export const firstDayOfWeek = languageCode => {
  const firstDayOfTheWeek = {
    en: 0,
    hr: 1,
    it: 1,
    sl: 1,
    de: 1,
    nl: 1,
    da: 1,
    pl: 1,
    hu: 1,
    fr: 1,
  };
  return (languageCode in firstDayOfTheWeek) ? firstDayOfTheWeek[languageCode]: firstDayOfTheWeek['en'];
};

export const months = languageCode => {
  const months = {
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    hr: [
      'siječanj',
      'veljača',
      'ožujak',
      'travanj',
      'svibanj',
      'lipanj',
      'srpanj',
      'kolovoz',
      'rujan',
      'listopad',
      'studeni',
      'prosinac',
    ],
    it: [
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre',
    ],
    sl: [
      'januar',
      'februar',
      'marec',
      'april',
      'maj',
      'junij',
      'julij',
      'avgust',
      'september',
      'oktober',
      'november',
      'december',
    ],
    de: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    nl: [
      'januari',
      'februari',
      'maart',
      'april',
      'mei',
      'juni',
      'juli',
      'augustus',
      'september',
      'oktober',
      'november',
      'december',
    ],
    da: [
      'januar',
      'februar',
      'marts',
      'april',
      'maj',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'december',
    ],
    pl: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    hu: [
      'január',
      'február',
      'március',
      'április',
      'május',
      'június',
      'július',
      'augusztus',
      'szeptember',
      'október',
      'november',
      'december',
    ],
    fr: [
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
  };
  return (languageCode in months) ? months[languageCode]: months['en'];
};

export const weekdays = languageCode => {
  const weekdays = {
    en: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    hr: [
      'nedjelja',
      'ponedjeljak',
      'utorak',
      'srijeda',
      'četvrtak',
      'petak',
      'subota',
    ],
    it: [
      'domenica',
      'lunedì',
      'martedì',
      'mercoledì',
      'giovedì',
      'venerdì',
      'sabato',
    ],
    sl: [
      'nedelja',
      'ponedeljek',
      'torek',
      'sreda',
      'četrtek',
      'petek',
      'sobota',
    ],
    de: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
    nl: [
      'zondag',
      'maandag',
      'dinsdag',
      'woensdag',
      'donderdag',
      'vrijdag',
      'zaterdag',
    ],
    da: [
      'søndag',
      'mandag',
      'tirsdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lørdag',
    ],
    pl: [
      'niedziela',
      'poniedziałek',
      'wtorek',
      'środa',
      'czwartek',
      'piątek',
      'sobota',
    ],
    hu: [
      'vasárnap',
      'hétfő',
      'kedd',
      'szerda',
      'csütörtök',
      'péntek',
      'szombaton',
    ],
    fr: [
      'dimanche',
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
    ],
  };
  return (languageCode in weekdays) ? weekdays[languageCode]: weekdays['en'];
};

export const weekdaysShort = languageCode => {
  const weekdaysShort = {
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    hr: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
    it: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
    sl: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
    de: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
    nl: ['zo.', 'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.'],
    da: ['Søn.', 'Man.', 'Tirs.', 'Ons.', 'Tors.', 'Fre.', 'Lør.'],
    pl: ['nie.', 'pon.', 'wto.', 'śro.', 'czw.', 'pią.', 'sob.'],
    hu: ['Vas.', 'H.', 'K.', 'Sze.', 'Csüt.', 'P.', 'Szo.'],
    fr: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  };
  return (languageCode in weekdaysShort) ? weekdaysShort[languageCode]: weekdaysShort['en'];
};

export const dateFormat = languageCode => {
  return 'DD.MM.YYYY.';
  // const dateFormat = {
  //   en: 'MM/DD/YYYY',
  //   hr: 'D.M.YYYY.',
  //   it: 'DD/MM/YYYY',
  //   sl: 'DD.MM.YYYY',
  //   de: 'YYYY-MM-DD',
  //   nl: 'DD-MM-YYYY',
  // };
  // return (languageCode in dateFormat) ? dateFormat[languageCode]: dateFormat['en'];
};

export const dateFormatUnicode = languageCode => {
  return 'dd.MM.yyyy.';
  // const dateFormat = {
  //   en: 'MM/dd/yyyy',
  //   hr: 'd.M.yyyy.',
  //   it: 'dd/MM/yyyy',
  //   sl: 'dd.MM.yyyy',
  //   de: 'yyyy-MM-dd',
  //   nl: 'dd-MM-yyyy',
  // };
  // return (languageCode in dateFormat) ? dateFormat[languageCode]: dateFormat['en'];
};

export const minDateFormatUnicodeLength = languageCode => {
  return 11;
  // const dateFormat = {
  //   en: 10,
  //   hr: 9,
  //   it: 10,
  //   sl: 10,
  //   de: 10,
  //   nl: 10,
  // };
  // return (languageCode in dateFormat) ? dateFormat[languageCode]: dateFormat['en'];
};


// WEBPACK FOOTER //
// ./src/js/search/DateI18n.js